import isEmpty from "lodash/isEmpty";
import { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useIsMobile } from "../../actions/ui";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@material-ui/core";
import { fileInfoList } from "../../v2_actions/customer_file_info";

const useStyles = makeStyles((theme) => ({
  uploadButton: {
    width: 180,
    height: 25,
  },
  cancelButton: {
    width: 180,
    height: 25,
    backgroundColor: "#606060",
  },
  photographWrapper: {
    bottom: 20,
    width: 100,
    height: 100,
    margin: "auto",
    background: "#fff",
    cursor: "pointer",
    position: "relative",
    border: "dashed 1px #000",
    [theme.breakpoints.down("sm")]: {
      width: 100,
      height: 100,
      marginTop: 20,
    },
  },
  privacyPolicy: {
    marginTop: -10,
    paddingBottom: 10,
    color: "black",
    margin: "auto",
    fontSize: 12,
    [theme.breakpoints.down("sm")]: {
      width: "80%",
    },
    "& a": {
      fontSize: 12,
    }
  },
  facialRecognitionText: {
    fontSize: 13,
    color: "#000",
    textAlign: "center",
    padding: "0 8px",
    wordWrap: "break-word",
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
    },
  },
  uploadSelfieButton: {
    height: 25,
    "& p": {
      fontSize: 12,
      fontWeight: 600,
    },
  },
  closeIcon: {
    right: "1px",
    top: "1px",
    color: "#000",
    cursor: "pointer",
    position: "absolute",
    fontSize: "20px !important",
  },
  previewImage: {
    maxWidth: "90px",
    maxHeight: "80px",
    objectFit: "contain",
    display: "block",
  },
  previewWrapper: {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

export const PhotographUploader = ({
  preview,
  onChange,
  disabled,
  setPreview,
  gallery_id,
  maxFileLimit,
  fileAnnotations,
  customButtonStyle,
  clearFacialRecognition,
  setIsPhotographUploading,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { open, getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles);
      setIsLoading(true);
      setIsPhotographUploading(true);
      const reader = new FileReader();
      reader.onloadend = () => {
        sessionStorage.setItem("customer_selfie_preview", reader.result);
      };
      reader.readAsDataURL(acceptedFiles[0]);
      dispatch(
        fileInfoList.upload(
          acceptedFiles[0],
          gallery_id,
          undefined,
          (file_info) => {
            onChange(file_info);
            setIsLoading(false);
            setIsPhotographUploading(false);
          },
        ),
      );
    },
  });

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach((file) => window.URL.revokeObjectURL(file.preview));
    },
    [files],
  );

  useEffect(() => {
    files.map((file) => setPreview(URL.createObjectURL(file)));
  }, [files]);

  const renderFacialRecognitionSelfiePreview = () => {
    return (
      <div onClick={open} className={classes.previewWrapper}>
        {preview && <img src={preview} className={classes.previewImage} />}
        {!preview && (
          <p className={classes.facialRecognitionText}>
            Load a Selfie
          </p>
        )}
      </div>
    );
  };

  const renderPrivacyPolicy = () => {
    return (
      <div className={classes.privacyPolicy}>
        By uploading a selfie, you agree to our <a href="https://info.bossfotos.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a> on how we process your image
      </div>
    )
  }

  const renderClearFacialRecognitionFilter = () => {
    return (
      <>
        <CloseIcon
          className={classes.closeIcon}
          onClick={clearFacialRecognition}
        />
      </>
    );
  };

  const renderCancelUploadButton = () => {
    return (
      <Button
        onClick={clearFacialRecognition}
        variant="contained"
        sx={{ backgroundColor: "#606060" }}
        className={`${customButtonStyle} ${classes.cancelButton}`}
      >
        <p>Cancel</p>
      </Button>
    );
  };

  const renderUploadButton = () => {
    return (
      <Button
        variant="contained"
        disabled={disabled || isLoading}
        className={`${classes.uploadButton} ${customButtonStyle}`}
        isValueSet={!isEmpty(files)}
      >
        <div {...getRootProps({ className: classes.dropzone })}>
          <input {...getInputProps()} />
          <p>
            {isLoading && "Uploading..."}
            {!isLoading && disabled && "Uploaded Selfie"}
            {!isLoading && !disabled && "Upload a Selfie"}
          </p>
        </div>
      </Button>
    );
  };

  return (
    <>
      <div className={classes.photographWrapper}>
        {renderFacialRecognitionSelfiePreview(open)}
        {preview && renderClearFacialRecognitionFilter()}
      </div>
      {renderPrivacyPolicy()}
      {!isMobile && renderUploadButton()}
      {isMobile && (
        <Stack
          spacing={3}
          direction="row"
          alignItems="center"
          justifyContent="center"
        >
          <span>{renderCancelUploadButton()}</span>
          <span>{renderUploadButton()}</span>
        </Stack>
      )}
    </>
  );
};
